const initialState = () => {
  return {
    configuration:null,
    developmentFileList: null,
    loading: false,
    errors: {
      applicationError: {
        hasError: null,
        error: []
      },
      configurationError: {
        hasError: null,
        error: []
      },
      maintenanceError: {
        hasError: null,
        error: ""
      }
    }
  };
};

export default initialState;
